import { Component, Inject, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { faLock } from "@fortawesome/pro-solid-svg-icons";
@Component({
    selector: "app-rename",
    templateUrl: "./rename.component.html",
    styleUrls: ["./rename.component.scss"],
    standalone: false
})
export class RenameDialogComponent implements OnInit {
  public categories: any;

  public renameForm!: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,

    public dialogRef: MatDialogRef<RenameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data && data.field) {
      this.field = data.field;
      this.name = data.field.name;
      this.alias = data.field.alias || this.name;
    }
  }
  field!: any;
  name!: string;
  alias: string = "";
  faLock = faLock;

  onNoClick(): void {
    this.dialogRef.close();
  }

  updateField() {
    this.field.alias = this.renameForm.controls["alias"].value;
    this.dialogRef.close(this.field);
  }

  ngOnInit(): void {
    this.renameForm = this.fb.group({
      name: new UntypedFormControl({ value: this.name, disabled: true }),
      alias: new UntypedFormControl({ value: this.alias, disabled: false }),
    });
  }
}
